<template>
  <div>
    <ErrorMessage
      v-show="errorMessage != null && errorMessage != ''"
      :msg="errorMessage"
    ></ErrorMessage>
    <select
      ref="selectFocus"
      v-model="option"
      :isFocus="isFocus"
      class="form-select form_select_new page-body-font pt-0 pb-0"
      style="color: rgb(0, 0, 0); font-family: 'メイリオ', 'Meiryo', sans-serif"
      :class="errorStyle"
      :disabled="disabled"
      @click="select"
      @input="$emit('input', $event.target.value)"
    >
      <option v-show="required" value="">ーー</option>
      <option v-for="item in items" :key="item.name" :value="item.id">
        {{ item.name }}
      </option>
    </select>
  </div>
</template>

<script>
import ErrorMessage from './ErrorMessage.vue'
import { mapGetters } from 'vuex'
import { getDropDowns } from '@/api/common/warekiDropDown'

// 令和（最新）には、プラス5年（システム稼動開始時は、1～10となる。）
const INCREASE_YEAR = 5

export default {
  name: 'WarekiSelect',
  components: { ErrorMessage },
  props: {
    errorMessage: {
      type: String,
      default: ''
    }, // エラーメッセージ
    value: {
      type: [String, Number],
      default: -1
    }, // 選択値
    optionName: {
      type: String,
      default: null
    }, // 元号名称
    optionYear: {
      type: Number,
      default: -1
    }, // 選択値「西暦年」
    temporaryG: {
      type: [String, Number],
      default: -1,
      required: false
    }, // 選択値「元号」
    temporaryY: {
      type: [String, Number],
      default: -1,
      required: false
    }, // 選択値「和暦年」
    temporaryM: {
      type: [String, Number],
      default: -1,
      required: false
    }, // 選択値「月」
    temporaryD: {
      type: [String, Number],
      default: -1,
      required: false
    }, // 選択値「月」
    disabled: Boolean,
    options: {
      type: Array,
      required: false,
      default: () => []
    }, // 指定のプルダウンデータ
    required: {
      type: Boolean,
      default: true
    }, // 「ーー」を設定
    kind: {
      type: String,
      default: 'G'
    }, // 元号「G」、年「Y」、月「M」、日「D」種別
    isFocus: {
      type: Boolean,
      default: false
    }, // フォーカス
    gengoRomaRyakkiFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const that = this
    return {
      option: that.setDefaultVal(this.value), // 選択値
      tempG: that.setDefaultVal(this.temporaryG), // 選択元号値
      tempNextG: that.setDefaultVal(this.temporaryG),
      tempY: that.setDefaultVal(this.temporaryY), // 選択年値
      tempM: that.setDefaultVal(this.temporaryM), // 選択月値
      errorStyle: '', // エラーメッセージ
      items: this.options || [], // デフォルトリスト
      warekiList: [] // 元号のプルダウンデータ
    }
  },
  computed: {
    ...mapGetters(['gengoInfo', 'gengoYear']), // 元号選択リスト
    category: () => {
      return this.kind === 'G'
    }
  },
  watch: {
    errorMessage: {
      immediate: true,
      handler(Vue) {
        if (Vue != null && Vue !== '') {
          this.errorStyle = 'error_style'
        } else {
          this.errorStyle = ''
        }
      }
    },
    temporaryG(newVal) {
      this.tempG = this.setDefaultVal(newVal)

      if (this.kind === 'Y') {
        this.tempY = this.option
        const index = this.warekiList.indexOf(this.tempG)
        this.tempNextG = this.warekiList[index - 1]

        // 年の情報取得
        this.getYearList()
      }

      if (this.kind === 'D') {
        // 日の情報取得
        this.getMonthDay()
      }
    },
    temporaryY(newVal) {
      if (this.kind === 'M' && !newVal && !this.tempY) {
        this.option = ''
      }

      if (this.kind === 'D') {
        this.tempY = this.setDefaultVal(newVal)
        // 日の情報取得
        this.getMonthDay()
      }
    },
    temporaryM(newVal) {
      this.tempM = this.setDefaultVal(newVal)
      const index = this.warekiList.indexOf(this.tempG)
      this.tempNextG = this.warekiList[index - 1]

      if (this.kind === 'D') {
        // 日の情報取得
        this.getMonthDay()
      }
    },
    option(newVal) {
      if (this.kind === 'G') {
        if (this.items && this.items.length !== 0) {
          const result = this.items.find(v => {
            return v.id === newVal
          })

          if (result && newVal) {
            this.$emit('update:optionName', result.name)
          } else {
            this.$emit('update:optionName', '')
            // 年号は空白の場合、年は空白に設定する
            this.$emit('update:temporaryY', '')
            this.$emit('update:temporaryM', '')
            this.$emit('update:temporaryD', '')
          }
        }
      }

      if (this.kind === 'Y') {
        if (!this.tempG || !this.option) {
          this.$emit('update:optionYear', -1)
        } else {
          this.$emit('update:optionYear', parseInt(this.tempG) + parseInt(this.option) - 1)
        }
      }

      if (this.kind === 'M' && (!this.value || this.value === '-1')) {
        this.option = ''
        this.$emit('update:temporaryD', '')
      }
    },
    value() {
      this.option = this.setDefaultVal(this.value)
    }
  },
  async created() {
    if (!this.gengoInfo || this.gengoInfo.length === 0) {
      const result = await getDropDowns()

      if (result !== 0) {
        this.$store.commit('SET_GENGOLIST', result.data)
        this.$store.commit('SET_GENGOYEAR', result.data[0].gengoStartYear)
      }

      this.init()
    } else {
      this.init()
    }
  },
  mounted() {
    if ((!this.value || parseInt(this.value) === -1) && this.value !== '') {
      switch (this.kind) {
        case 'G':
          // 元号初期化
          this.option = this.gengoYear

          break
        case 'Y':
          // 年初期化
          var currentY = new Date().getFullYear()
          var yearMax = currentY - this.gengoYear + 1
          this.option = yearMax

          break
        case 'M':
          // 月初期化
          this.option = ''

          break
        case 'D':
          // 日初期化
          this.option = ''

          break
        default:
          // 元号初期化
          this.option = this.gengoYear

          break
      }
      this.$emit('input', this.option)
    }

    this.$nextTick(() => {
      this.focus()
    })
  },
  methods: {
    /**
     * フォーカス処理
     */
    focus() {
      if (this.isFocus) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.selectFocus) {
              this.$refs.selectFocus.focus()
            }
          }, 800)
        })
      }
    },
    /**
     * 概要：初期化情報取得
     */
    init() {
      switch (this.kind) {
        case 'G':
          // 元号の情報取得
          this.items = this.rsResults(this.gengoInfo)

          if (this.option) {
            const obj = this.items.find(v => {
              return v.id === this.option
            })

            this.$emit('update:optionName', obj?.name)
          } else {
            this.$emit('update:optionName', '')
          }

          break
        case 'Y':
          // 元号の情報取得
          for (const result of this.rsResults(this.gengoInfo)) {
            this.warekiList.push(result.id)
          }

          this.tempNextG = this.warekiList[this.warekiList.indexOf(this.tempG) - 1]

          // 年の情報取得
          this.getYearList()

          break
        case 'M':
          // 月の情報取得
          var month = Array.from({ length: 12 }, (key, value) => ({
            id: value + 1,
            name: value + 1
          }))
          this.items = month

          break
        case 'D':
          for (const result of this.rsResults(this.gengoInfo)) {
            this.warekiList.push(result.id)
          }

          this.tempNextG = this.warekiList[this.warekiList.indexOf(this.tempG) - 1]

          // 日の情報を取得
          this.getMonthDay()

          break
        default:
          // 元号の情報取得
          this.items = this.rsResults(this.gengoInfo)

          break
      }
    },
    /**
     * 概要：方法事件実行
     */
    select() {
      this.$emit('select')
    },
    /**
     * 概要：うるう年フラグ
     * @param {number} year 年
     */
    leapYear(year) {
      return !(year % (year % 100 ? 4 : 400))
    },
    /**
     * 概要：元号プルダウンリスト取得
     * @param {Array} items プルダウンリスト
     */
    rsResults(items) {
      const result = []

      if (items) {
        for (const item of items) {
          const obj = {
            id: item.gengoStartYear,
            name: this.gengoRomaRyakkiFlag
              ? item.gengoRomaRyakki
              : item.gengoName
          }

          result.push(obj)
        }
      }

      return result
    },
    /**
     * 概要：年プルダウンリスト取得
     */
    getYearList() {
      let yearMax = 0

      if ((!this.option || this.option === -1) && this.tempY) {
        // 年の情報取得
        this.tempG = this.gengoYear
      }

      if (!this.tempG) {
        this.option = ''
        this.items = []
      } else if (this.tempG >= this.gengoYear) {
        // 令和以後
        const currentY = new Date().getFullYear()
        yearMax = currentY - this.gengoYear + 1 + INCREASE_YEAR
        this.option = yearMax < this.option ? yearMax : this.option

        this.items = Array.from({ length: yearMax }, (k, v) => ({
          id: v + 1,
          name: v + 1
        }))
      } else {
        // 令和以前
        yearMax = Math.abs(this.tempNextG - this.tempG + 1)
        this.option = yearMax < this.option ? yearMax : this.option

        this.items = Array.from({ length: yearMax }, (k, v) => ({
          id: v + 1,
          name: v + 1
        }))
      }
    },
    /**
     * 概要：月プルダウンリスト取得
     */
    getMonthDay() {
      let day = 0
      let currentYM = 0

      // 元号初期化
      if (this.isDayDefault()) {
        day = Array.from({ length: 30 }, (k, v) => ({
          id: v + 1,
          name: v + 1
        }))

        this.items = day
        this.option = ''
      } else {
        currentYM = this.tempG + this.tempY - 1

        // 選択する年がうるう年、且つ「2月」が選択された場合、日プルダウンに1～29日を設定する。
        if (this.tempM === 2 && this.leapYear(currentYM)) {
          day = Array.from({ length: 29 }, (k, v) => ({
            id: v + 1,
            name: v + 1
          }))

          this.items = day
          this.option = this.option > 29 ? 29 : this.option
        } else  {
          if(this.tempM === 2 ){
            // 上記3.1.3以外の場合、日プルダウンに1～28日を設定する。
            day = Array.from({ length: 28 }, (k, v) => ({
              id: v + 1,
              name: v + 1
            }))

            this.items = day
            this.option = this.option > 28 ? 28 : this.option
          } 
          // 「4、6、9、11月」が選択された場合、日プルダウンに1～30日を設定する。
          if ([4, 6, 9, 11].includes(this.tempM)) {
            day = Array.from({ length: 30 }, (k, v) => ({
              id: v + 1,
              name: v + 1
            }))

            this.items = day
            this.option = this.option > 30 ? 30 : this.option
          }

          // 「1、3、5、7、8、10、12月」が選択された場合、日プルダウンに1～31日を設定する。
          if ([1, 3, 5, 7, 8, 10, 12].includes(this.tempM)) {
            day = Array.from({ length: 31 }, (k, v) => ({
              id: v + 1,
              name: v + 1
            }))

            this.items = day
          } 
        }

        
      }
    },
    /**
     * 概要：数値変換
     * @param {var} val 入力値
     */
    setDefaultVal(val) {
      return val === '' ? '' : parseInt(val)
    },
    isDayDefault() {
      return (
        !this.tempG ||
        this.tempG === -1 ||
        !this.tempY ||
        this.tempY === -1 ||
        !this.tempM ||
        this.tempM === -1
      )
    }
  }
}
</script>

<style scoped lang="scss">
.error_style {
  background-color: rgb(255, 220, 221);
  border-color: red;
  border: 1;
}
.form_select_new {
  height: 25px !important;
  font-size: 14px;
}
</style>
